import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../pages/AuthContext"; // Adjust this path if needed

export default function ProtectedRoute({ children }) {
  const { isAuthenticated } = useAuth();

  return isAuthenticated ? children : <Navigate to="/Laram" />;
}
